export function createXLSheetdata(kitsList) {
    kitsList.find((ticketDetails, index) => {

               

                kitsList[index]._id=kitsList[index].id
                delete kitsList[index]['id']

                kitsList[index]._sku=kitsList[index].sku
                delete kitsList[index]['sku']

                kitsList[index]._sku_name=kitsList[index].sku_name
                delete kitsList[index]['sku_name']

                kitsList[index]._type=kitsList[index].type
                delete kitsList[index]['type']

                kitsList[index]._category=kitsList[index].category
                delete kitsList[index]['category']

                kitsList[index]._status=kitsList[index].status
                delete kitsList[index]['status']

                kitsList[index]._city=kitsList[index].city
                delete kitsList[index]['city']


                kitsList[index]._map_id=kitsList[index].map_id
                delete kitsList[index]['map_id']

                kitsList[index]._kit_id=kitsList[index].kit_id
                delete kitsList[index]['kit_id']

                kitsList[index]._product_id=kitsList[index].product_id
                delete kitsList[index]['product_id']                

                kitsList[index]._name=kitsList[index].name
                delete kitsList[index]['name']

                kitsList[index]._description=kitsList[index].description
                delete kitsList[index]['description']

                kitsList[index]._base_quantity=kitsList[index].base_quantity
                delete kitsList[index]['base_quantity']

                kitsList[index]._sequence=kitsList[index].sequence
                delete kitsList[index]['sequence']

                kitsList[index]._quantity=kitsList[index].quantity
                delete kitsList[index]['quantity']

                kitsList[index]._estimated_cost=kitsList[index].estimated_cost
                delete kitsList[index]['estimated_cost']


                kitsList[index]._uom=kitsList[index].uom
                delete kitsList[index]['uom']


                delete kitsList[index]['kits']
                delete kitsList[index]['products_count']


                return false
            })   
            return kitsList
}




// WEBPACK FOOTER //
// ./src/modules/Kits/services/helpers.js